export default __webpack_public_path__ + "static/media/account.07d83c53.svg";